import React from 'react';
import PropTypes from 'prop-types';

const TwitterIcon = () => (
  <svg width={20} height={19} viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#twitter_clip0)">
      <path d="M10.007.378h-.333a9 9 0 000 18h.333a9 9 0 000-18z" fill="#50ABF1" />
      <path
        d="M5.413 12.289c.802.499 1.753.788 2.772.788 2.864 0 5.186-2.28 5.186-5.091 0-.07-.002-.14-.005-.21.104-.08.745-.584.902-.908 0 0-.52.212-1.03.262h-.003l.003-.001c.047-.031.703-.47.791-.992 0 0-.368.193-.883.362a5.97 5.97 0 01-.267.08 1.83 1.83 0 00-1.328-.565c-1.005 0-1.82.8-1.82 1.786 0 .139.017.274.048.404-.14-.005-2.28-.123-3.735-1.853 0 0-.87 1.165.519 2.364 0 0-.422-.017-.786-.23 0 0-.134 1.412 1.438 1.773 0 0-.31.115-.803.033 0 0 .276 1.141 1.672 1.248 0 0-1.104.98-2.671.75z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="twitter_clip0">
        <path fill="#fff" transform="translate(.674 .378)" d="M0 0h18.333v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

TwitterIcon.propTypes = {};

export default TwitterIcon;
